import { Theme } from '@eversports/react-components/design-tokens/theme'
import Flex from '@eversports/react-components/primitives/Flex'
import Heading from '@eversports/react-components/primitives/Heading'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'

import { Localized } from '../../../localization/react'
import { EventBookableItem } from '../../../typings/BookableItem'
import Trainer from '../../../typings/Trainer'
import { SettleWith } from '../../../typings/Product'
import Address from './Address'
import BookingDetailsName from './BookingDetailsName'
import BookingDetailsSettleWith from './BookingDetailsSettleWith'
import BookingDetailsTimeBlock from './BookingDetailsTimeBlock'

const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontSize: theme.fontSizing.large,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.fontSizing.default,
    },
  },
}))

interface Props {
  bookableItem: EventBookableItem
  trainer: Trainer | null
  start: string | null
  end: string | null
  settleWith?: SettleWith | null
}

export function PrivateSessionDetailsContent({ bookableItem, trainer, start, end, settleWith }: Props) {
  const classes = useStyles()
  const timeRange = start && end ? { start, end } : null

  return (
    <Flex flexDirection="column" verticalSpacing={['dense', 'wide']}>
      <Heading is="h2" className={classes.heading} marginTop={['default', 'default', 'none']}>
        <Localized id="booking-details" />
      </Heading>
      <div>
        <Flex flexDirection="column" marginBottom="wide">
          <BookingDetailsName
            type="event"
            venueName={bookableItem.venue.name}
            sport={bookableItem.sport.name}
            activityName={bookableItem.activityName}
          />
        </Flex>
        <Flex flexDirection="column" verticalSpacing="default">
          <Address location={bookableItem.location} />
          {trainer && (
            <Flex alignItems="center">
              <Icon icon={Icons.PERSON} color="subtleText" marginRight="dense" />
              <Text fontWeight="bold" size="small">
                {trainer.nickname}
              </Text>
            </Flex>
          )}
          {timeRange && <BookingDetailsTimeBlock type="court" timeRange={timeRange} />}
          {settleWith && <BookingDetailsSettleWith settleWith={settleWith} />}
        </Flex>
      </div>
    </Flex>
  )
}
